import { render, staticRenderFns } from "./PlatSelect.vue?vue&type=template&id=726879b8&scoped=true&"
import script from "./PlatSelect.vue?vue&type=script&lang=js&"
export * from "./PlatSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726879b8",
  null
  
)

export default component.exports